import { render, staticRenderFns } from "./phoneDetail.vue?vue&type=template&id=6298582c&scoped=true&"
import script from "./phoneDetail.vue?vue&type=script&lang=js&"
export * from "./phoneDetail.vue?vue&type=script&lang=js&"
import style0 from "./phoneDetail.vue?vue&type=style&index=0&id=6298582c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6298582c",
  null
  
)

export default component.exports